/**
 * Profile compatibility route.
 *
 * Slice 04 makes /you canonical. Keep /profile working without routing
 * through the mutable legacy Ikigai surface.
 */

import { Navigate } from 'react-router-dom';

export function Profile() {
  return <Navigate to="/you" replace />;
}
